var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "send_svg2__a",
    x1: 0,
    x2: 200,
    y1: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M191.2.6c-2.6-.8-5.5-.8-8.1.1L8.4 63.1C1.9 65.4-1.5 72.6.8 79.2c-1.8 1.7 38.8 39 40.2 41 4.5 4.4 11.4 4.8 16.4 1l129.7-99.8-53.6 166.8c-.4 1.6-2.7 2.3-3.9 1.1l-49.5-44.6c-5.4-5.2-15-.9-14.8 6.6v33.5c0 4.9 4 8.8 8.8 8.9 2.3 0 4.5-.9 6.2-2.5l17.4-16.9 25.1 22.6c6.4 6.1 18 3 20.4-5.5l56.1-175c2.1-6.6-1.5-13.7-8.1-15.8m-140 112.5c-.9.7-2.3.6-3.1-.2L10.9 76.7c-.9-.9-1-2.4 0-3.4.5-.9 171.5-61.3 172.4-61.8zm24.2 68.5v-27.4L90 167.4z",
    style: {
      fill: "url(#send_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgSend;